import { Bell, List, MagnifyingGlass, User } from "phosphor-react";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Panel from "./panel";

const Index = () => {
  const [menu, setMenu] = useState({
    menuOpen: false,
    menuAnimation: false,
  });

  const menuClickHandler = () => {
    setMenu({
      menuOpen: true,
      menuAnimation: true,
    });
  };

  const closeHandler = () => {
    setMenu({
      menuOpen: false,
      menuAnimation: true,
    });
    setTimeout(() => {
      setMenu({
        menuOpen: false,
        menuAnimation: false,
      });
    }, 500);
  };

  let menuClose = [];
  if (!menu.menuAnimation) {
    menuClose.push("header_menuBounceOutUp__ZalT4");
    document.body.style.overflow = "";
  } else if (menu.menuAnimation) {
    document.body.style.overflow = "hidden";
  }
  return (
    <>
      <div className="lg:hidden">
        <Panel
          Open={menu}
          classClose={menuClose}
          closeClickHandler={closeHandler}
        />
      </div>
      <div className="py-4 bg-gray-50 border-b border-slate-100">
        <div className="hidden lg:flex  items-center justify-between w-full">
          <div className="lg:flex items-center ">
            <a href="/" className="mr-10">
              <svg
                width="91"
                height="19"
                viewBox="0 0 91 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.776003 17.712C0.440003 17.36 0.272003 16.808 0.272003 16.056C0.272003 15.304 0.440003 14.76 0.776003 14.424C1.128 14.072 1.68 13.896 2.432 13.896C3.184 13.896 3.728 14.072 4.064 14.424C4.416 14.76 4.592 15.304 4.592 16.056C4.592 16.808 4.416 17.36 4.064 17.712C3.728 18.048 3.184 18.216 2.432 18.216C1.68 18.216 1.128 18.048 0.776003 17.712Z"
                  fill="#111827"
                />
                <path
                  d="M10.8832 18H7.49919V1.20001H12.9952L18.1072 14.232L23.1712 1.20001H28.6672V18H25.3072V4.65601L19.9792 18H16.1872L10.8832 4.68001V18Z"
                  fill="#111827"
                />
                <path
                  d="M40.0325 0.984009C43.0405 0.984009 45.2245 1.66401 46.5845 3.02401C47.9605 4.38401 48.6485 6.57601 48.6485 9.60001C48.6485 12.608 47.9605 14.8 46.5845 16.176C45.2245 17.536 43.0405 18.216 40.0325 18.216C37.0085 18.216 34.8165 17.536 33.4565 16.176C32.0965 14.8 31.4165 12.608 31.4165 9.60001C31.4165 6.57601 32.0965 4.38401 33.4565 3.02401C34.8165 1.66401 37.0085 0.984009 40.0325 0.984009ZM36.0245 5.44801C35.1925 6.31201 34.7765 7.69601 34.7765 9.60001C34.7765 11.504 35.1925 12.888 36.0245 13.752C36.8565 14.616 38.1925 15.048 40.0325 15.048C41.8725 15.048 43.2085 14.616 44.0405 13.752C44.8725 12.888 45.2885 11.504 45.2885 9.60001C45.2885 7.69601 44.8725 6.31201 44.0405 5.44801C43.2085 4.56801 41.8725 4.12801 40.0325 4.12801C38.1925 4.12801 36.8565 4.56801 36.0245 5.44801Z"
                  fill="#111827"
                />
                <path
                  d="M49.2836 1.20001H52.8596L58.6196 14.448L64.3556 1.20001H67.9556L60.5156 18H56.7236L49.2836 1.20001Z"
                  fill="#111827"
                />
                <path d="M70.007 18V1.20001H73.391V18H70.007Z" fill="#111827" />
                <path
                  d="M90.6793 18H76.6633V1.20001H90.6793V4.36801H80.0473V8.11201H89.4793V11.088H80.0473V14.832H90.6793V18Z"
                  fill="#111827"
                />
              </svg>
            </a>
            <nav className="flex space-x-6">
              <Link
                to="/"
                className="hover:text-sky-500 transition-all duration-300 ease-in-out"
              >
                Home
              </Link>
              <Link
                to="/movies"
                className="hover:text-sky-500 transition-all duration-300 ease-in-out"
              >
                Movies
              </Link>
              <Link
                to="/genres"
                className="flex items-center space-x-2 hover:text-sky-500 transition-all duration-300 ease-in-out"
              >
                <span>Genres</span>
              </Link>
            </nav>
          </div>
          <Link
            to="search"
            className="flex text-sm text-slate-400 font-normal transition-all duration-300 ease-in-out hover:-translate-y-1 hover:scale-[1.01] hover:shadow-lg hover:bg-slate-100 bg-slate-100 h-14 w-96  items-center justify-between px-4 rounded-xl"
          >
            <span>Search a movie, series...</span>
            <MagnifyingGlass size={24} />
          </Link>
          <div className="flex space-x-6">
            <Link
              to="/"
              className="relative flex transition-all duration-300 ease-in-out bg-slate-100 text-slate-900 hover:bg-slate-200 h-14 w-14 items-center justify-center rounded-xl"
            >
              <span className="absolute -top-1 -right-1 rounded-full h-3 w-3 bg-green-500"></span>
              <Bell size={24} />
            </Link>
            <Link
              to="/auth-login"
              className="flex space-x-3 transition-all duration-300 ease-in-out bg-sky-500 text-white hover:bg-sky-600 h-14 px-6 items-center justify-center rounded-xl"
            >
              <User size={24} />
              <span>Login</span>
            </Link>
          </div>
        </div>

        <div className="flex items-center justify-between lg:hidden">
          <button
            onClick={menuClickHandler}
            className="p-2 transition-all duration-300 ease-in-out bg-slate-100 text-slate-900 hover:bg-slate-200 items-center justify-center rounded-xl"
          >
            <List size={24} weight="fill" />
          </button>
          <a href="/" className="">
            <svg
              width="91"
              height="19"
              viewBox="0 0 91 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.776003 17.712C0.440003 17.36 0.272003 16.808 0.272003 16.056C0.272003 15.304 0.440003 14.76 0.776003 14.424C1.128 14.072 1.68 13.896 2.432 13.896C3.184 13.896 3.728 14.072 4.064 14.424C4.416 14.76 4.592 15.304 4.592 16.056C4.592 16.808 4.416 17.36 4.064 17.712C3.728 18.048 3.184 18.216 2.432 18.216C1.68 18.216 1.128 18.048 0.776003 17.712Z"
                fill="#111827"
              />
              <path
                d="M10.8832 18H7.49919V1.20001H12.9952L18.1072 14.232L23.1712 1.20001H28.6672V18H25.3072V4.65601L19.9792 18H16.1872L10.8832 4.68001V18Z"
                fill="#111827"
              />
              <path
                d="M40.0325 0.984009C43.0405 0.984009 45.2245 1.66401 46.5845 3.02401C47.9605 4.38401 48.6485 6.57601 48.6485 9.60001C48.6485 12.608 47.9605 14.8 46.5845 16.176C45.2245 17.536 43.0405 18.216 40.0325 18.216C37.0085 18.216 34.8165 17.536 33.4565 16.176C32.0965 14.8 31.4165 12.608 31.4165 9.60001C31.4165 6.57601 32.0965 4.38401 33.4565 3.02401C34.8165 1.66401 37.0085 0.984009 40.0325 0.984009ZM36.0245 5.44801C35.1925 6.31201 34.7765 7.69601 34.7765 9.60001C34.7765 11.504 35.1925 12.888 36.0245 13.752C36.8565 14.616 38.1925 15.048 40.0325 15.048C41.8725 15.048 43.2085 14.616 44.0405 13.752C44.8725 12.888 45.2885 11.504 45.2885 9.60001C45.2885 7.69601 44.8725 6.31201 44.0405 5.44801C43.2085 4.56801 41.8725 4.12801 40.0325 4.12801C38.1925 4.12801 36.8565 4.56801 36.0245 5.44801Z"
                fill="#111827"
              />
              <path
                d="M49.2836 1.20001H52.8596L58.6196 14.448L64.3556 1.20001H67.9556L60.5156 18H56.7236L49.2836 1.20001Z"
                fill="#111827"
              />
              <path d="M70.007 18V1.20001H73.391V18H70.007Z" fill="#111827" />
              <path
                d="M90.6793 18H76.6633V1.20001H90.6793V4.36801H80.0473V8.11201H89.4793V11.088H80.0473V14.832H90.6793V18Z"
                fill="#111827"
              />
            </svg>
          </a>
          <Link
            to="/search"
            className="p-2 transition-all duration-300 ease-in-out bg-slate-100 text-slate-900 hover:bg-slate-200 items-center justify-center rounded-xl"
          >
            <MagnifyingGlass size={24} />
          </Link>
          <div className="hidden"></div>
        </div>
      </div>
    </>
  );
};

export default Index;
